export const config = {
  rowSelection: false,
  pagination: false,
  fieldControl: false,
  tableType: 'antd',
  search: false,
  columns: [
    {
      title: '项目/通项',
      dataIndex: ['dtlName'],
      width: 200,
    },
    {
      title: '类型',
      dataIndex: ['busTypeName'],
      width: 160,
    },
    {
      title: '适用门店',
      dataIndex: ['shopList'],
      render: 'jsonRender',
      width: 200,
    },
    {
      title: '创建人',
      dataIndex: ['createdByName'],
      width: 160,
    },
    {
      title: '创建时间',
      dataIndex: ['createdTime'],
      width: 180,
      itemType: 'dateTime',
    },
    {
      title: '操作',
      dataIndex: 'actionRender',
      render: 'actionRender',
      fixed: 'right',
      width: 160,
    },
  ],
}
